import { useContext } from 'react';
import {
  QueryFunctionContext,
  useQueries,
  useQuery,
  UseQueryOptions,
} from 'react-query';
import { loan_application } from '@axo/shared/data-access/types';
import {
  applicationKeys,
  parseApplicationKey,
} from '../cache-keys/applicationKeys';
import { getAPI, IDataAccessContext } from '@axo/shared/data-access/provider';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { loan_application_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../query-function';

function map({
  queryKey,
}: QueryFunctionContext<ReturnType<(typeof applicationKeys)['detail']>>) {
  const { applicationID } = parseApplicationKey(queryKey);
  return applicationID || '';
}

export function useApplicationDetail(
  applicationID: string | undefined,
  onSuccess?: (data: loan_application.LoanApplication) => void,
) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = applicationKeys.detail({
    applicationID,
  });
  return useQuery(
    cacheKey,
    queryFunction(loan_application_api.getLoanApplication(api), map),
    {
      enabled: state.user.token.length > 0 && applicationID !== undefined,
      onSuccess,
    },
  );
}

export function useApplicationsDetails(applicationIDs: string[]) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const queries = applicationIDs.map<
    UseQueryOptions<
      loan_application.LoanApplication,
      unknown,
      loan_application.LoanApplication,
      ReturnType<typeof applicationKeys.detail>
    >
  >((applicationID) => ({
    queryKey: applicationKeys.detail({
      applicationID,
    }),
    queryFn: queryFunction(loan_application_api.getLoanApplication(api), map),
    enabled:
      state.user.token.length > 0 &&
      applicationIDs &&
      applicationIDs.length > 0,
  }));
  return useQueries(queries);
}

/**
 * @deprecated
 */
export function fetchApplicationDetails(
  context: IDataAccessContext,
  applicationID: string,
) {
  const { queryClient } = context;
  const cacheKey = applicationKeys.detail({
    applicationID,
  });
  return queryClient?.fetchQuery({
    queryKey: cacheKey,
    queryFn: queryFunction(
      loan_application_api.getLoanApplication(getAPI(context)),
      map,
    ),
  });
}
